<template>
  <b-dropdown right class="excel-export-btn">
    <template #button-content>
      <span style="height: max-content">
        <img :src="baseUrl + '/vue/img/excel_icon.png'" alt='export-excel' class='xlsx-img'>
      </span>
    </template>
    <b-dropdown-item @click="onClick('konversta')">
      Формат сервиса «Конверста»
    </b-dropdown-item>
    <b-dropdown-item @click="onClick('rolis')">
      Формат сервиса «РОЛИС»
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'XlsExport',

  props: {
    src: {
      type: String
    },
    model: {
      type: String
    },
    baseUrl: {
      type: String
    }
  },

  methods: {
    dataHref (format) {
      let search = ''
      const param = []
      for (const p of new URLSearchParams(window.location.search.substr(1))) {
        param.push(p.join('='))
      }
      search = param.join('&')

      return this.baseUrl + '/export/save-xls?' + search +
        '&model=' + this.model + '&format=' + format
    },

    onClick (format) {
      const vue = this;
      const dataHref = this.dataHref(format)
      if (dataHref) {
        vue.$emit('change-status', 'Экспорт данных начался.', 'info')
        axios({
          method: 'get',
          url: dataHref,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            Accept: 'application/json, text/javascript, */*; q=0.01'
          },
          responseType: 'blob'
        }).then(function (result) {
          if (Number(result.status) !== 400) {
            const url = window.URL.createObjectURL(new Blob([result.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'export_' + moment().format('DD.MM.YYYY_hh:mm:ss') + '.xlsx')
            link.click()
            link.remove()
            vue.$emit('change-status', 'Данные успешно экспортированы', 'success')
          } else {
            vue.$emit('change-status', result.message ? result.message : 'Не удалось экспортировать данные.', 'danger')
          }
        })
          .catch(function (result) {
            vue.$emit('change-status', 'Не удалось экспортировать данные.', 'danger')
          });
      }
    }
  }
}

</script>

<style scoped>

</style>
